import { Exchange, ShiftExchange } from '../../../../../@paco/entities/Exchange/Exchange';
import { compareAsc } from '../../../../../helpers/date';

export default function sortRequestsByDate(requests: (ShiftExchange | Exchange)[]) {
    return requests
        .sort((a, b) => compareAsc(b.createdAt, a.createdAt));
}
